import Vue from 'vue';
import VueRouter from 'vue-router';

import ExemptionRouter from './modules/exemption';
import ErrorRouter from './modules/error';
import EnterpriseRouter from './modules/enterprise';
import DueRouter from './modules/due';
import User from './modules/user';
import store from '../store/store';

Vue.use(VueRouter);
const routes = [
    ...ExemptionRouter,
    ...ErrorRouter,
    ...EnterpriseRouter,
    ...DueRouter,
    ...User,
    { path: '*', redirect: { name: 'exemption-search' } }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

function isTokenExpired(token) {
    try {
        const parts = token.split('.');
        if (parts.length !== 3) {
            return false;
        }
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(base64));
        return payload.exp !== undefined && Date.now() / 1000 > payload.exp;
    } catch {
        return false;
    }
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.isAuthRequired)) {
        const token = store.getters.accessToken;
        if (null === token || isTokenExpired(token)) {
            store.commit('DELETE_ACCESS_TOKEN');
            next({ name: 'login' });

            return;
        }
    }

    if (to.matched.some(record => record.meta.isEnterpriseRequired)) {
        if (null === store.getters.enterpriseUuid) {
            next({ name: 'enterprise-list' });

            return;
        }
    }

    next();
})

export default router;
